import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { usePostApiRequest } from "../../helpers/api";
import { FcApproval } from "react-icons/fc";

const OrderDetailItem = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [processData, setProcessData] = useState([]);
  const postApiRequest = usePostApiRequest();

  const handleToggleAccordion = async (index, item) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
      await getProcessData(item);
    }
  };

  const getProcessData = async (item) => {
    const data = {
      OrderId: item.OrderId,
      StyleCode: item.StyleCode,
    };

    try {
      const response = await postApiRequest({
        url: "/Customer/OrderProcessDetail",
        method: "POST",
        data: data,
        noToast: true,
      });
      setProcessData(response.Data[0]);
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  return (
    <>
      {data.map((item, index) => (
        <div key={index} className="order_item">
          <img
            src={process.env.REact_APP_IMG_URL + item.ImagePath}
            alt={item.StyleCode}
            className="order_item_image"
          />
          <div className="order_item_details_con">
            <p>{item.StyleCode}</p>
            <div className="order_item_specification">
              <p className="item_category">
                <span>Category:</span> {item.Category}
              </p>
              <p className="item_color">
                <span>Color:</span> {item.Color}
              </p>
              <p className="item_size">
                <span>Size:</span> {item.Size}
              </p>
            </div>
            <div className="order_item_specification">
              <p className="item_qty">
                <span>Qty:</span> {item.OrderQty}
              </p>
            </div>
            {item.CustomerProductionInstruction && (
              <div className="order_item_specification">
                <p className="item_qty">
                  <span>Instructions:</span>{" "}
                  {item.CustomerProductionInstruction}
                </p>
              </div>
            )}
            <div className="order_item_specification bottom">
              {item.OrderProceedStatus === "Ordered" ? (
                <span className="success_badge">Order</span>
              ) : (
                <span className="warning_badge">Material pending</span>
              )}
              {item.OrderId !== 0 && (
                <>
                  <p>
                    <span>ORDER ID:</span> #{item.OrderId}
                  </p>
                  <p>
                    <span>ORDER NO:</span> #{item.OrderNo}
                  </p>
                </>
              )}
            </div>
          </div>
          <div className="order_item_right">
            <div className="order_item_weight">
              {item.TotGrossWt}GM | {item.TotDiaWt} CT
            </div>
            {item.OrderId !== 0 && (
              <button
                className="button"
                onClick={() => handleToggleAccordion(index, item)}
              >
                {activeIndex === index ? "HIDE PROGRESS" : "VIEW PROGRESS"}
              </button>
            )}
          </div>
          <div
            className={`bottom_details_con ${
              activeIndex === index ? "opened" : ""
            }`}
          >
            {item.OrderId !== 0 && (
              <div className="bottom_details_con_inner">
                <div className="bottom_details_inner_con">
                  <div className="accordion_title">PRODUCT PROGRESS</div>
                  <span
                    className="close_icon"
                    onClick={() => setActiveIndex(null)}
                  >
                    <IoClose size={"1.5rem"} />
                  </span>

                  <div className="bottom_block">
                    <span>
                      <FcApproval
                        style={{ marginRight: "5px" }}
                        size={"1.3rem"}
                      />
                      In Department
                    </span>
                    <div>
                      {processData.DepartmentCode} -{" "}
                      {processData.DepartmentName}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default OrderDetailItem;
